import { faThumbtack } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { gateTitleToHeading } from 'components/documents/access_settings/helper';
import { accessLevelColors } from 'bundles/leads/helper/lead_access_levels';

export function createDropdownItems(isPinned, value, modifyAccessLevel, accessLevels) {
  const dropdownMenuItems = [];

  if (isPinned) {
    const textToShow = <span>Unpin from {gateTitleToHeading(value)}</span>;
    const color = accessLevelColors[value];
    dropdownMenuItems.push({
      key: 'unpin',
      content: <div className="d-flex gap-1 position-relative align-items-center">
        <svg
          className="position-absolute"
          height="13"
          strokeLinecap="round"
          strokeWidth="1.5px"
          viewBox="0 0 16 13"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line stroke={color} strokeLinecap="round" x1="1" x2="15" y1="1" y2="12"/>
          <line stroke="white" x1="1" x2="15" y1="3" y2="14"/>
        </svg>
        <FontAwesomeIcon className="fa-fw" color={color} icon={faThumbtack}/>
        {textToShow}
      </div>,
      onClick: () => modifyAccessLevel('no_override')
    });
  }

  ['public_access', 'low', 'medium', 'high'].forEach((accessLevel) => {
    const isValidDropdownItem = accessLevels.includes(accessLevel);

    if (isValidDropdownItem && (!isPinned || accessLevel !== value)) {
      const textToShow = <span>Pin to {gateTitleToHeading(accessLevel)}</span>;
      dropdownMenuItems.push({
        key: accessLevel,
        content: <div className="d-flex gap-3 align-items-center">
          <FontAwesomeIcon className="fa-fw" color={accessLevelColors[accessLevel]} icon={faThumbtack}/>
          {textToShow}
        </div>,
        onClick: () => modifyAccessLevel(accessLevel)
      });
    }
  });

  return dropdownMenuItems;
}
